import moment from 'moment';
import { Form, Tabs, Badge } from 'antd';
import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import '@ant-design/compatible/assets/index.css';
import { connect } from 'react-redux';
import Analytics from '../helpers/Analytics';
import Permissions from '../auth/Permissions';

import CustomConfirmModal from '../common/modals/CustomConfirmModal';
import WarningHeader from '../common/text/WarningHeader';

import StepsContainer from '../common/containers/StepsContainer';
import ProjectAddGeneral from './ProjectAddGeneral';
import ProjectAddFiles from './ProjectAddFiles';
import ProjectFormTemplates from './ProjectFormTemplates';
import ProjectAddBilling from './ProjectAddBilling';
import ProjectAddBillingRate from './ProjectBillingRate/ProjectAddBillingRate';
import ProjectSimpleFormList from './ProjectSimpleFormList';
import ProjectAddCostCode from './ProjectAddCostCode';
import ProjectAddEquipment from './ProjectEquipment/ProjectAddEquipment';
import ProjectAddMaterials from './ProjectMaterials/ProjectAddMaterials';
import ProjectBudgetTracking from './ProjectBudgetTracking/ProjectBudgetTracking';
import ProjectBudgetTrackingCreate from './ProjectBudgetTracking/redesign/ProjectBudgetTrackingCreate';
import ProjectProgress from './ProjectProgress/ProjectProgress';
import ProjectScheduleOfValues from './ProjectScheduleOfValues/ProjectScheduleOfValues';
import ProjectAnalytics from './ProjectAnalytics/ProjectAnalytics';
import ProjectNotes from './ProjectNotes';
import ProjectPayables from './ProjectPayables';
import AttachmentTab from '../attachment/AttachmentTab';
import GanttSchedule from '../schedule/GanttSchedule/GanttSchedule';
import { calculateExpirationReminder } from './projectHelpers';

import BoardLinkView from '../boards/BoardLinkView';

import {
  getIdMap,
  getHighestNumber,
  sortByNumber,
  isNullOrUndefined,
} from '../helpers/helpers';

import exportProject from './projectExport';

import { PROJECT_COSTCODE_TYPE } from '../nux/nux.constants';

import config from '../config';
import {
  getProjectAttachments,
  getMyProjectTags,
  markProjectTagsAsRead,
  getProjectCustomCategoryEstimates,
} from './state/projects.actions';
import ProjectsService from './state/projects.service';
import { getCostcodeCategoryAssignmentData } from '../costcodes/state/costcodes.actions';
import { getBuckets } from '../buckets/state/buckets.actions';
import getGoogleMapKey from '../common/keys';
import { getNewCategoryAssignments } from '../helpers/costcodeHelpers';
import { FOOTER_HEIGHT } from '../constants/Styles';
import CostTracking from './ProjectBudgetTracking/redesign/manage/CostTracking';
import { ProjectGlobalCostcodesProvider } from '../costcodes/ProjectGlobalCostcodes';

const { TabPane } = Tabs;

const EXCLUDE_SET = new Set(['Work Order', 'Invoice']);
const tabStyle = {
  minHeight: '100%',
  width: '100%',
};

const parseEquipmentSchedules = (eqs = []) => {
  const eqMap = {};
  eqs.forEach((eq) => {
    if (eq.startTime && eq.endTime) {
      eqMap[eq.id] = {
        ...eq,
        range: [
          eq.startTime ? moment(eq.startTime) : null,
          eq.endTime ? moment(eq.endTime) : null,
        ],
      };
    }
  });
  return eqMap;
};

const getKeyToStep = (hasCostTracking) => ({
  general: 0,
  Billing: 1,
  'Cost Codes': 2,
  Equipment: hasCostTracking ? 2 : 3,
  'Budget Tracking': config.showEquipment ? 4 : 3,
  'Cost Tracking': 3,
});

const PROGRESS_TAB = 'Progress';
const PAYABLES_TAB = 'Payables';
const BILLING_TAB = 'Billing';
const WORK_ORDERS_TAB = 'Work Orders';
const CHANGES_TAB = 'Changes';
const OTHER_FORMS_TAB = 'Other Forms';
const ANALYTICS_TAB = 'Analytics';
const ATTACHMENTS = 'attachments';
const RATES_TAB = 'Rates';

class ProjectAddView extends React.Component {
  constructor(props) {
    super(props);
    const {
      id,
      geofence = null,
      projectCostcodes = [],
      phases = [],
      editing,
      address,
      lat,
      lng,
      currentStep,
      activeTab = 'general',
      firstApprover,
      secondApprover,
      positionNames = [],
      equipment: propEquipment = [],
      equipmentSchedules: propEquipSchedules = [],
      cardLinks = [],
      projectTypeId,
      type,
      useCoordinates,
      divisionId,
    } = this.props;

    if (editing) this.initializeValues();

    this.state = {
      geofenceEnabled: geofence !== null,
      geofenceSize: geofence ? geofence / 1000 : 0.3,
      chosen: projectCostcodes,
      phaseCodes: phases,
      formDivisionId: divisionId,
      activeTab,
      showList: projectCostcodes.length > 0,
      address,
      lat,
      lng,
      currentStep,
      firstApprover: this.mapApprover(firstApprover,positionNames),
      secondApprover: this.mapApprover(secondApprover,positionNames),
      showEquipment: propEquipment.length > 0,
      equipment: propEquipment,
      equipmentSchedule: parseEquipmentSchedules(propEquipSchedules),
      ourLinks: cardLinks.filter((cardLink) => (
        cardLink.projectId === id
      )),
      projectTypeId,
      useCoordinates,
      gotAttachments: false,
      attachmentsLoading: true,
      hasLoadedCategoryAssignments: false,
    };

    if (geofence !== null) {
      this.state.geofenceSize = geofence / 1000;
    }

    this.onPlaceChanged = this.placeChanged.bind(this);
    this.onGeofenceEnableChanged = this.geofenceEnableChanged.bind(this);
    this.onUseCoordinatesChanged = this.useCoordinatesChanged.bind(this);
    this.onGeofenceSizeChanged = this.geofenceSizeChanged.bind(this);
    this.onApproverChanged1 = this.approverChanged1.bind(this);
    this.onApproverChanged2 = this.approverChanged2.bind(this);

    this.onCheckChanged = this.changeShowList.bind(this);
    this.onPhaseChanged = this.phaseChanged.bind(this);
    this.onCostCodeListClear = this.clearCostCodeList.bind(this);
    this.onCostCodeRemove = this.tryRemoveCostCode.bind(this);
    this.onCostcodeAdd = this.costcodeAdded.bind(this);
    this.onCostcodeEdit = this.costcodeEdited.bind(this);

    this.onAddPhaseCode = this.addPhaseCode.bind(this);
    this.onRemovePhaseCode = this.tryRemovePhaseCode.bind(this);
    this.onClearUnphasedInputs = this.clearUnphasedInputs.bind(this);
    this.onClearPhasesList = this.clearPhaseCodes.bind(this);
    this.onEditPhaseCostCodes = this.editPhaseCostCodes.bind(this);
    this.onEditCostcodeEstimateChanged = this.editCostcodeEstimate.bind(this);
    this.onEditPhaseDetails = this.editPhaseDetails.bind(this);
    this.onClearDates = this.clearDates.bind(this);
    this.onClearBudget = this.clearBudget.bind(this);
    this.onEquipmentToggle = this.toggleEquipment.bind(this);
    this.onEquipmentAdd = this.addEquipment.bind(this);
    this.onExistingEquipmentAdd = this.addExistingEquipment.bind(this);
    this.onEquipmentRemove = this.removeEquipment.bind(this);
    this.onEquipmentDateChanged = this.equipmentDateChanged.bind(this);
    this.onEquipmentDateRemoved = this.removeEquipmentDate.bind(this);
    this.onEditEquipment = this.editEquipment.bind(this);
    this.onApplyTemplate = this.applyTemplate.bind(this);
    this.onImportBudget = this.importBudget.bind(this);
    this.onProjectTypeChanged = this.projectTypeChanged.bind(this);
    this.onLabelsChanged = this.onLabelsChanged.bind(this);

    this.onTabChange = this.tabChanged.bind(this);

    this.onExport = this.export.bind(this);

    this.phaseCodeIdCounter = 0;
    this.costcodeCounter = 0;
    this.equipmentCounter = 0;

    // If we are creating from a project type page, we need to lock project type
    if (type) {
      this.onProjectTypeChanged(type);
    }
  }

  async componentDidMount() {
    const {
      id,
      getBuckets,
      hideBucketDropdown,
      getMyProjectTags,
      getCostcodeCategoryAssignmentData,
      getProjectCustomCategoryEstimates,
      isAdd,
      formRef,
      settings: {
        suggestNumbers,
      } = {},
    } = this.props;
    if (!hideBucketDropdown) getBuckets();
    getMyProjectTags();
    if (id) {
      getCostcodeCategoryAssignmentData({ projectId: id });
      getProjectCustomCategoryEstimates({ projectId: id });
    }

    if (location?.state?.activeTab) {
      const tab = location.state.activeTab;
      this.setState({ activeTab: tab });
      this.props.onActiveTabChange?.(tab);
    }

    if (isAdd && suggestNumbers) {
      const currentNumber = formRef?.current?.getFieldValue('number');
      if (!currentNumber && formRef?.current) {
        const nextNumber = await this.loadSuggestedNumber();
        if (!nextNumber) return;
        formRef.current.setFieldsValue({ number: nextNumber });
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      currentStep: prevStep,
      phases: prevPhases = [],
      editing: prevEditing,
      cardLinks: prevCardLinks,
      id: prevId,
      newEstimatedSubContractTotalValue: prevNewEstimatedSubContractTotalValue,
      categoryAssignments: prevCategoryAssignments = {},
    } = prevProps;
    const {
      id,
      geofence = null,
      currentStep,
      phases = [],
      editing,
      cardLinks = [],
      newEstimatedSubContractTotalValue,
      categoryAssignments = {},
      projectCostcodes = [],
      divisionId,
      isAdd,
    } = this.props;

    const {
      hasLoadedCategoryAssignments,
      chosen: stateChosen = [],
      phaseCodes: statePhaseCodes = [],
    } = this.state;

    if (prevPhases !== phases && !(phases.length === 0 && prevPhases.length === 0)) {
      this.setState({
        phaseCodes: phases,
      });
    }
    if (
      prevProps.projectCostcodes !== projectCostcodes
      && (
        !(isAdd || editing)
        || (stateChosen.length === 0 && projectCostcodes.length > 0)
      )
    ) {
      this.setState({
        chosen: projectCostcodes,
        showList: projectCostcodes.length > 0,
      });
    }
    if (divisionId && divisionId !== prevProps.divisionId) {
      this.setState({
        formDivisionId: divisionId,
      });
    }
    if (currentStep !== prevStep || currentStep !== this.state.currentStep) {
      this.setState({
        currentStep,
      });
    }
    if (editing && !prevEditing) {
      this.initializeValues();
      const {
        projectCostcodes: editCostcodes = [],
        phases: editPhases = [],
      } = this.props;

      this.setState({
        chosen: editCostcodes,
        phaseCodes: editPhases,
        showList: editCostcodes.length > 0,
        ...(geofence !== null && {
          geofenceEnabled: true,
          geofenceSize: geofence / 1000,
        }),
      });
    }
    if (newEstimatedSubContractTotalValue !== prevNewEstimatedSubContractTotalValue && newEstimatedSubContractTotalValue !== null) {
      this.setState({
        newEstimatedSubContractTotalValue,
      });
      if (this.props.formRef?.current) {
        this.props.formRef.current.setFieldsValue({
          estimatedSubContractTotalValue: newEstimatedSubContractTotalValue,
        });
      }
    }
    if (id && (cardLinks !== prevCardLinks || id !== prevId)) {
      this.setState({
        ourLinks: cardLinks.filter((cardLink) => (
          cardLink.projectId === id
        )),
      });
    }
    if (id && categoryAssignments !== prevCategoryAssignments && !hasLoadedCategoryAssignments) {
      const newChosen = stateChosen.map((cc) => ({
        ...cc,
        categoryAssignments: categoryAssignments?.[cc.id]?.unphased ?? {},
      }));
      const newPhaseCodes = statePhaseCodes.map((phase) => ({
        ...phase,
        costcodes: phase?.costcodes?.map((cc) => ({
          ...cc,
          categoryAssignments: categoryAssignments?.[cc.id]?.[phase.id] ?? {},
        })),
      }));
      this.setState({
        hasLoadedCategoryAssignments: true,
        chosen: newChosen,
        phaseCodes: newPhaseCodes,
      });
    }
  }

  componentWillUnmount() {
    const {
      onShowFilesChanged,
    } = this.props;
    if (onShowFilesChanged) onShowFilesChanged(false);
  }

  initializeValues() {
    const {
      geofence = null,
      projectCostcodes = [],
      phases,
      equipment = [],
      equipmentSchedules = [],
      useCoordinates,
      onValuesChanged,
    } = this.props;
    onValuesChanged('costcodes', projectCostcodes);
    onValuesChanged('geofence', geofence ? geofence : undefined);
    onValuesChanged('phases', phases);
    onValuesChanged('equipment', equipment);
    onValuesChanged('equipmentSchedule', parseEquipmentSchedules((equipmentSchedules)));
    onValuesChanged('useCoordinates', !!useCoordinates);
  }

  mapApprover(approver, positionNames) {
    for (var p of positionNames) {
      if (approver === p.id.toString()) return `Any ${p.name}`
    }
    const users = this.props.users.filter((u)=>u.id===approver)
    return users[0] ? users[0].name : undefined
  }

  placeChanged(place) {
    const existingVals = this.props.formRef.current.getFieldsValue();
    this.props.formRef.current.setFieldsValue({ ...existingVals,...place });
  }

  useCoordinatesChanged(value) {
    const {
      useCoordinates,
    } = this.state;
    const {
      onValuesChanged,
    } = this.props;
    const newValue = !isNullOrUndefined(value) ? value : !useCoordinates;
    onValuesChanged('useCoordinates', newValue);
    this.setState({
      useCoordinates: newValue,
    });
  }

  geofenceEnableChanged() {
    const {
      geofenceEnabled,
    } = this.state;
    Analytics.track(`Project/Geofence/${geofenceEnabled ? 'Disabled' : 'Enabled'}`);
    this.props.onValuesChanged('geofence', geofenceEnabled
      ? undefined : this.state.geofenceSize * 1000);
    this.setState({
      geofenceEnabled: !geofenceEnabled,
    });

  }

  geofenceSizeChanged(geofenceSize) {
    if (isNaN(geofenceSize)) return;
    this.setState({
      geofenceSize,
    });
    this.props.onValuesChanged('geofence',geofenceSize * 1000);
  }

  approverChanged1(approver) {
    this.props.onValuesChanged('firstApprover', approver)
  }

  approverChanged2(approver) {
    this.props.onValuesChanged('secondApprover', approver)
  }

  projectTypeChanged(projectTypeId) {
    this.props.onValuesChanged('projectTypeId', projectTypeId);
    this.setState({
      projectTypeId,
    });
  }

  onLabelsChanged(labels) {
    this.props.onValuesChanged('labels', labels);
  }

  changeShowList() {
    const {
      nux = new Set(),
      createNuxEntry,
    } = this.props;
    this.setState({
      showList: !this.state.showList,
    },() => {
      if (!this.state.showList) {
        this.clearCostCodeList();
        this.clearPhaseCodes();
      } else {
        if (!nux.has(PROJECT_COSTCODE_TYPE)) {
          createNuxEntry(PROJECT_COSTCODE_TYPE);
        }
      }
    });
  }

  phaseChanged(costcode,checked) {
    const newChosen = this.state.chosen.map((chosen) => {
      const res = { ...chosen };
      if (chosen.id === costcode.id) {
        res.phased = checked;
      }
      return res;
    }).sort(sortByNumber('code'));
    this.setState({
      chosen: newChosen,
    });
    this.props.onValuesChanged('costcodes',newChosen);
  }

  clearUnphasedInputs() {
    const chosen = this.state.chosen.map((cc) => ({
      ...cc, hours: null, estimatedCost: null, estimatedQuantity: null, units: null
    }))

    this.setState({
      chosen,
    });
    this.props.onValuesChanged('costcodes', chosen);
  }

  clearCostCodeList() {
    this.setState({
      chosen: [],
    });
    this.props.onValuesChanged('costcodes',[]);
  }

  removeCostCode(record) {
    const { onValuesChanged } = this.props;
    const {
      chosen: stateChosen = [],
      phaseCodes = [],
    } = this.state;
    const chosen = stateChosen.filter((cc) => cc.id !== record.id).sort(sortByNumber('code'));

    const newPhases = phaseCodes.map((phase) => ({
      ...phase,
      costcodes: phase.costcodes.filter((cc) => cc.id !== record.id),
    }));
    this.setState({
      chosen,
      phaseCodes: newPhases,
    });

    onValuesChanged('costcodes', chosen);
    onValuesChanged('phases', newPhases);
  }

  tryRemoveCostCode(record) {
    const { id } = this.props;
    if (id) {
      CustomConfirmModal({
        title: `Delete Cost Code '${record?.name}'?`,
        content: (
          <div>
            <WarningHeader justify="center" />
            <br />
            Deleting a cost code will unlink all tracked entries for that cost code
          </div>
        ),
        onOk: () => {
          this.removeCostCode(record);
        },
        okText: 'Delete',
      });
    } else {
      this.removeCostCode(record);
    }
  }

  costcodeAdded(values) {
    const {
      chosen: stateChosen = [],
    } = this.state;
    const {
      onValuesChanged,
    } = this.props;
    const chosen = stateChosen.concat(
      values.map((cc, index) => ({
        ...cc,
        id: cc.id ?? this.costcodeCounter + index,
        isNew: !cc.id,
      })),
    ).sort(sortByNumber('code'));

    this.costcodeCounter += values.length;
    this.setState({
      chosen,
    });
    onValuesChanged('costcodes', chosen);
  }

  costcodeEdited(id, newData = {}) {
    const {
      onValuesChanged,
      actionButtonEnabled
    } = this.props;
    const {
      chosen: stateChosen = [],
    } = this.state;

    const chosen = stateChosen.map((cc) => {
      if (cc.id !== id) return cc;
      return {
        ...cc,
        ...newData,
        isNew: true,
        // Need to set this as new or else backend
        // overwrites the changes with whats in the DB for the global code
      };
    });

    let missingKey = false;
    let codeConflict = false;
    let nameConflict = false;

    // Name is unique per project
    // Code is unique per project
    const codeSet = new Set();
    const nameSet = new Set();

    chosen.forEach((data) => {
      const name = data.name ? data.name.trim().toLowerCase() : data.name;
      const code = data.code ? data.code.trim().toLowerCase() : data.code;
      const desc = data.description ? data.description.trim().toLowerCase() : data.description;
      if (!name || !code || !desc) {
        missingKey = true;
      } else {
        if (nameSet.has(name)) nameConflict = true;
        nameSet.add(name);

        if (codeSet.has(code)) codeConflict = true;
        codeSet.add(code);
      }
    });

    this.setState({
      chosen,
    });

    onValuesChanged('costcodes', chosen);
    actionButtonEnabled(
      !missingKey
      && !nameConflict
      && !codeConflict,
    );
  }

  addPhaseCode(record) {
    const {
      phaseCodes: statePhaseCodes = [],
      chosen: stateChosen = [],
    } = this.state;
    const {
      onValuesChanged,
    } = this.props;

    const phaseCodes = [{
      ...record,
      id: this.phaseCodeIdCounter,
    }].concat(statePhaseCodes);

    // Update chosen array to mark costcodes as phased
    const phasedCostcodeIds = new Set((record.costcodes || []).map((cc) => cc.id));
    const chosen = stateChosen.map((cc) => {
      if (phasedCostcodeIds.has(cc.id) && !cc.phased) {
        return { ...cc, phased: true };
      }
      return cc;
    });

    this.setState({
      phaseCodes,
      chosen,
    });
    this.phaseCodeIdCounter += 1;
    onValuesChanged('phases', phaseCodes);
    onValuesChanged('costcodes', chosen);
  }

  removePhaseCode(record) {
    const {
      onValuesChanged,
    } = this.props;
    const {
      phaseCodes = [],
      chosen: stateChosen = [],
    } = this.state;
    const filteredCodes = phaseCodes.filter((pc) => pc.id !== record.id);

    // Costcodes that were only on this phase must be removed from the project
    const costcodeIdsOnDeletedPhase = new Set((record.costcodes || []).map((cc) => cc.id));
    const costcodeIdsOnOtherPhases = new Set();
    filteredCodes.forEach((phase) => {
      (phase.costcodes || []).forEach((cc) => costcodeIdsOnOtherPhases.add(cc.id));
    });
    const idsToRemoveFromProject = [...costcodeIdsOnDeletedPhase].filter(
      (id) => !costcodeIdsOnOtherPhases.has(id),
    );
    const idsToRemoveSet = new Set(idsToRemoveFromProject);
    const chosen = stateChosen.filter((cc) => !idsToRemoveSet.has(cc.id));

    this.setState({
      phaseCodes: filteredCodes,
      chosen,
    });
    onValuesChanged('phases', filteredCodes);
    onValuesChanged('costcodes', chosen);
  }

  tryRemovePhaseCode(record) {
    const { id } = this.props;
    if (id) {
      CustomConfirmModal({
        title: `Delete Phase '${record?.name}'?`,
        content: (
          <div>
            <WarningHeader justify="center" />
            <br />
            Deleting a phase will unlink all tracked entries for that phase
          </div>
        ),
        onOk: () => {
          this.removePhaseCode(record);
        },
        okText: 'Delete',
      });
    } else {
      this.removePhaseCode(record);
    }
  }

  clearPhaseCodes() {
    this.setState({
      phaseCodes: [],
    });
    this.phaseCodeIdCounter = 0;
    this.props.onValuesChanged('phases',[]);
  }

  editPhaseCostCodes(phaseCodeId, costcodes) {
    const {
      phaseCodes: statePhaseCodes = [],
      chosen: stateChosen = [],
    } = this.state;
    const {
      onValuesChanged,
    } = this.props;
    const phaseCodes = statePhaseCodes.map((pc) => {
      if (pc.id !== phaseCodeId) return pc;
      return { ...pc, costcodes };
    });

    // Get all costcode IDs that are in any phase after this update
    const allPhasedCostcodeIds = new Set();
    phaseCodes.forEach((phase) => {
      phase?.costcodes?.forEach((cc) => {
        allPhasedCostcodeIds.add(cc.id);
      });
    });

    // Update chosen array: mark as phased if in any phase, unphased if in no phase
    const chosen = stateChosen.map((cc) => {
      const isInAnyPhase = allPhasedCostcodeIds.has(cc.id);
      if (isInAnyPhase && !cc.phased) {
        return { ...cc, phased: true };
      }
      if (!isInAnyPhase && cc.phased) {
        return { ...cc, phased: false };
      }
      return cc;
    });

    this.setState({
      phaseCodes,
      chosen,
    });
    onValuesChanged('phases', phaseCodes);
    onValuesChanged('costcodes', chosen);
  }

  editCostcodeEstimate(costcode, data = {}) {
    const {
      onValuesChanged,
    } = this.props;
    const {
      chosen: stateChosen = [],
    } = this.state;
    const chosen = stateChosen?.map((cc) => {
      if (cc.id !== costcode.id) return cc;
      const newCategoryAssignments = getNewCategoryAssignments({
        oldCostcode: cc,
        newData: data,
      });
      const updatedCostcode = {
        ...cc,
        ...data,
        categoryAssignments: newCategoryAssignments,
      };
      return updatedCostcode;
    });

    this.setState({
      chosen,
    });
    onValuesChanged('costcodes', chosen);
  }

  editPhaseDetails(phaseCodeId, newDetails) {
    const phaseCodes = this.state.phaseCodes.map((pc) => {
      if (pc.id !== phaseCodeId) return pc;
      return { ...pc, ...newDetails };
    });
    this.setState({
      phaseCodes,
    });
    this.props.onValuesChanged('phases',phaseCodes);
  }

  clearDates() {
    const {
      phaseCodes = [],
    } = this.state;
    const newPhases = phaseCodes.map((phase) => {
      const { costcodes = [] } = phase;
      const newCC = costcodes.map((cc) => ({ ...cc, startDate: null, endDate: null }));
      return { ...phase, costcodes: newCC };
    });
    this.setState({
      phaseCodes: newPhases,
    });
    this.props.onValuesChanged('phases',newPhases);
  }

  clearBudget() {
    const chosen = this.state.chosen.map((cc) => {
      return {
        ...cc,
        hours: null,
      };
    });

    this.setState({
      chosen,
    });

    this.props.onValuesChanged('costcodes',chosen);
    this.clearPhaseCodes();
    this.props.onValuesChanged('budget',{
      estimatedLabourHours: null,
      estimatedLabourCost: null,
      dateRange: [null,null],
    });
  }

  toggleEquipment() {
    const {
      showEquipment,
    } = this.state;
    this.setState({
      showEquipment: !showEquipment,
    });
  }

  addEquipment(record) {
    const {
      equipment: stateEquipment = [],
    } = this.state;

    let recordsArray = record;

    if (!Array.isArray(record)) {
      recordsArray = [record];
    }

    const chosen = [...stateEquipment];

    recordsArray.forEach((eq) => {
      this.equipmentCounter += 1;
      const ourId = this.equipmentCounter.toString();
      chosen.push({
        ...eq,
        id: ourId,
        isNew: true,
      });
    });

    this.setState({
      equipment: chosen,
    });
    this.props.onValuesChanged('equipment', chosen);
  }

  addExistingEquipment(records) {
    const {
      equipment: stateEquipment = [],
    } = this.state;
    const chosen = stateEquipment.concat(records);

    this.setState({
      equipment: chosen,
    });
    this.props.onValuesChanged('equipment',chosen);
  }

  removeEquipment(record) {
    const {
      equipment: stateEquipment = [],
      equipmentSchedule = {},
    } = this.state;
    const newEquipment = stateEquipment.filter((eq) => eq.id !== record.id);

    const newSchedule = { ...equipmentSchedule };
    Object.keys(newSchedule).forEach((key) => {
      const [realId] = key.split('.');
      if (realId === record.id) {
        delete newSchedule[key];
      }
    });

    this.setState({
      equipment: newEquipment,
      equipmentSchedule: newSchedule,
    });
    this.props.onValuesChanged('equipment',newEquipment);
    this.props.onValuesChanged('equipmentSchedule',newSchedule);
  }

  editEquipment(equipmentId, newEq) {
    const {
      equipment: stateEquipment = [],
    } = this.state;
    const newEquipment = stateEquipment.map((eq) => {
      if (eq.id !== equipmentId) return eq;
      return {
        ...eq,
        ...newEq,
      };
    });
    this.setState({
      equipment: newEquipment,
    });
    this.props.onValuesChanged('equipment', newEquipment);
  }

  equipmentDateChanged({ id, range, name }) {
    const {
      equipmentSchedule = {},
    } = this.state;

    const newSchedule = { ...equipmentSchedule };
    const {
      [id]: existing = {},
    } = newSchedule;
    newSchedule[id] = { ...existing, range, name, id };

    this.setState({
      equipmentSchedule: newSchedule,
    });
    this.props.onValuesChanged('equipmentSchedule',newSchedule);
  }

  removeEquipmentDate({ id }) {
    const {
      equipmentSchedule = {},
    } = this.state;

    const newSchedule = { ...equipmentSchedule };
    delete newSchedule[id];
    this.setState({
      equipmentSchedule: newSchedule,
    });
    this.props.onValuesChanged('equipmentSchedule',newSchedule);
  }

  applyTemplate({ costcodes, phases }) {
    const {
      props: {
        onValuesChanged,
      },
    } = this;
    this.setState({
      showList: true,
      chosen: costcodes,
      phaseCodes: phases,
    });
    onValuesChanged('costcodes', costcodes);
    onValuesChanged('phases', phases);
  }

  importBudget({
    phaseCodes: newPhaseCodes,
    unphasedCostcodes: newUnphased,
    estimates: newEstimates,
    clearExisting = false,
  }) {
    const {
      props: {
        onValuesChanged,
        formRef: {
          current: form,
        } = {},
      },
      state: {
        chosen,
        phaseCodes,
      },
    } = this;
    const {
      startDate,
      endDate,
      ...restEstimates
    } = newEstimates;

    const dateRange = [
      startDate ? moment(startDate) : null,
      endDate ? moment(endDate) : null,
    ];

    // Update form values
    let newCostcodes;
    let newPhases;
    if (clearExisting) {
      const seenCodes = new Set();
      const phaseCostcodes = [];
      newPhaseCodes.forEach(({ costcodes: pcc = [] }) => {
        pcc.forEach((cc) => {
          if (!seenCodes.has(cc.code)) {
            seenCodes.add(cc.code);
            phaseCostcodes.push(cc);
          }
        });
      });
      newCostcodes = [...newUnphased, ...phaseCostcodes];
      newPhases = newPhaseCodes;
    } else {
      const byCode = getIdMap(chosen, 'code');
      const byName = getIdMap(chosen, 'name');
      const mergeImportedCostcode = (cc) => {
        const existing = byCode[cc.code] || byName[cc.name];
        if (!existing) {
          byCode[cc.code] = cc;
          byName[cc.name] = cc;
          return;
        }
        if (existing.code !== cc.code) delete byCode[existing.code];
        if (existing.name !== cc.name) delete byName[existing.name];
        const merged = {
          ...existing,
          ...cc,
          id: existing.id,
          isNew: existing.isNew,
        };
        byCode[merged.code] = merged;
        byName[merged.name] = merged;
      };
      newUnphased.forEach(mergeImportedCostcode);
      newPhaseCodes.forEach(({ costcodes = [] }) => costcodes.forEach(mergeImportedCostcode));
      const byId = {};
      Object.values(byCode).forEach((cc) => { byId[cc.id] = cc; });
      newCostcodes = Object.values(byId);
      // Phase rows still carry the preview's temporary ids. Point them at the
      // merged cost code so the phase link references a real costcodes row.
      const resolvedPhases = newPhaseCodes.map((phase) => {
        const seenIds = new Set();
        const costcodes = [];
        phase?.costcodes?.forEach((cc) => {
          const resolved = byCode[cc.code] || byName[cc.name] || cc;
          if (seenIds.has(resolved.id)) return;
          seenIds.add(resolved.id);
          if (resolved.id === cc.id) {
            costcodes.push(cc);
            return;
          }
          costcodes.push({
            ...cc,
            id: resolved.id,
            isNew: resolved.isNew,
          });
        });
        return {
          ...phase,
          costcodes,
        };
      });
      // Phases are allowed to have the same name, so not safe to replace existing
      newPhases = [...phaseCodes, ...resolvedPhases];
    }

    if (form) {
      const existingVals = form.getFieldsValue();
      form.setFieldsValue({ ...existingVals, dateRange, ...restEstimates });
    }
    // Update projectAddViewState
    this.setState({
      showList: true,
      chosen: newCostcodes,
      phaseCodes: newPhases,
      dateRange,
      ...restEstimates,
    });
    // Update projectList values
    onValuesChanged('budget', { ...restEstimates, dateRange });
    onValuesChanged('costcodes', newCostcodes);
    onValuesChanged('phases', newPhases);
  }

  export(isPDF) {
    const {
      projectCostcodes,
      name,
      number,
      startDate,
      endDate,
      labourCost,
      labourHours,
      companyImageURL,
      t,
    } = this.props;
    const {
      phaseCodes = [],
      chosen: chosenCostcodes = [],
    } = this.state;

    const unphasedCostcodes = (projectCostcodes || chosenCostcodes).filter((cc) => !cc.phased);
    Analytics.track('Project/Export',{ ExportFileType: isPDF ? 'pdf' : 'xlsx' })
    exportProject({
      isPDF,
      startDate,
      endDate,
      companyImageURL,
      name,
      number,
      labourCost,
      labourHours,
      unphasedCostcodes,
      phaseCodes,
      t,
    });
  }

  getGeneralPage() {
    const newProps = {};
    const {
      errors,
      customFields,
      setCustomFields,
    } = this.props;

    Object.keys(this.props).forEach((key) => {
      if (key !== 'address') {
        newProps[key] = this.props[key];
      }
    });

    return (
      <ProjectAddGeneral
        key={`${this.props.id}-info`}
        {...this.props}
        {...this.state}
        onPlaceChanged={this.onPlaceChanged}
        onGeofenceEnableChanged={this.onGeofenceEnableChanged}
        geofenceEnabled={this.state.geofenceEnabled}
        onGeofenceSizeChanged={this.onGeofenceSizeChanged}
        geofenceSize={this.state.geofenceSize}
        isNotDisplay={this.isNotDisplay}
        onApproverChanged1={this.onApproverChanged1}
        onApproverChanged2={this.onApproverChanged2}
        onProjectTypeChanged={this.onProjectTypeChanged}
        errors={errors}
        customField={customFields}
        setCustomFields={setCustomFields}
        googleMapURL={getGoogleMapKey()}
        loadingElement={<div style={{ height: '100%' }} />}
        onUseCoordinatesChanged={this.onUseCoordinatesChanged}
        onLabelsChanged={this.onLabelsChanged}
      />
    );
  }

  getPayablesPage() {
    const { activeTab } = this.state;
    const { id } = this.props;
    return (
      <ProjectPayables
        id={id}
        isNotDisplay={this.isNotDisplay}
        visible={activeTab === PAYABLES_TAB}
      />
    );
  }

  getAnalyticsPage() {
    const {
      id,
      projectTypeId,
    } = this.props;

    return (
      <ProjectAnalytics
        projectId={id}
        projectTypeId={projectTypeId}
      />
    );
  }

  getBillingPage() {
    const { activeTab } = this.state;
    return (
      <ProjectAddBilling
        {...this.props}
        isNotDisplay={this.isNotDisplay}
        visible={activeTab === BILLING_TAB}
      />
    );
  }

  getBillingRatesPage() {
    const {
      id,
      divisionId,
    } = this.props;
    return (
      <ProjectAddBillingRate
        projectId={id}
        divisionId={divisionId}
      />
    );
  }

  getSimpleFormList(type, visible) {
    return (
      <ProjectSimpleFormList
        {...this.props}
        isNotDisplay={this.isNotDisplay}
        type={type}
        visible={visible}
      />
    )
  }

  getOtherFormsList() {
    const { activeTab } = this.state;
    const formProps = { ...this.props };
    /*
      https://projectharbour.atlassian.net/browse/HARBOUR-5465
      When viewing this project from the project specific
      type view, this.props has the project type (e.g. Residential)
      and the spread passes that down to the form filtering to look for
      forms by type.

      Need to remove type so we can get all other forms
    */
    delete formProps.type;
    return (
      <ProjectSimpleFormList
        {...formProps}
        isNotDisplay={this.isNotDisplay}
        exclude={EXCLUDE_SET}
        visible={activeTab === OTHER_FORMS_TAB}
      />
    );
  }

  getCostcodePage() {
    const {
      formRef,
    } = this.props;
    const divisionId = (
      formRef && formRef.current ? formRef.current.getFieldValue('divisionId') : null
    );

    return (
      <ProjectAddCostCode
        key={`${this.props.id}-cc`}
        projectCostcodes={this.props.projectCostcodes}
        chosen={this.state.chosen}
        onCostcodeAdd={this.onCostcodeAdd}
        onCostcodeEdit={this.onCostcodeEdit}
        onCheckChanged={this.onCheckChanged}
        onPhaseChanged={this.onPhaseChanged}
        showList={this.state.showList}
        onListClear={this.onCostCodeListClear}
        onRemove={this.onCostCodeRemove}
        isNotDisplay={this.isNotDisplay}
        settings={this.props.settings}
        divisionId={divisionId}
        templateView={this.props.templateView}
        onApplyTemplate={this.onApplyTemplate}
      />
    );
  }

  getEquipmentPage() {
    const {
      formRef,
      id,
    } = this.props;
    const {
      showEquipment,
      equipment,
      equipmentSchedule = {},
      projectTypeId,
    } = this.state;
    const divisionId = (
      formRef && formRef.current ? formRef.current.getFieldValue('divisionId') : null
    );

    return (
      <ProjectAddEquipment
        isNotDisplay={this.isNotDisplay}
        divisionId={divisionId}
        showEquipment={showEquipment}
        onCheckChanged={this.onEquipmentToggle}
        equipment={equipment}
        onAdd={this.onEquipmentAdd}
        onAddExisting={this.onExistingEquipmentAdd}
        onRemove={this.onEquipmentRemove}
        projectId={id}
        projectTypeId={projectTypeId}
        equipmentSchedule={equipmentSchedule}
        onEquipmentDateChanged={this.onEquipmentDateChanged}
        onEquipmentDateRemoved={this.onEquipmentDateRemoved}
        onEditEquipment={this.onEditEquipment}
      />
    );
  }

  getMaterialsPage() {
    const {
      formRef,
      id,
    } = this.props;
    const divisionId = (
      formRef && formRef.current ? formRef.current.getFieldValue('divisionId') : null
    );

    return (
      <ProjectAddMaterials
        divisionId={divisionId}
        projectId={id}
      />
    );
  }

  getBudgetPage() {
    const {
      id,
      divisionId,
      formRef,
      labourHours,
      labourCost,
      estimatedMaterialCost,
      estimatedOverheadCost,
      estimatedEquipmentCost,
      estimatedBurdenRate,
      estimatedSubContractTotalValue,
      contractValue,
      startDate,
      endDate,
      createNuxEntry,
      nux,
      templateView,
      enableBuildEstimate,
      templateId,
      newEstimatedSubContractTotalValue,
    } = this.props;

    const {
      equipment = [],
    } = this.state;

    const formDivisionId = formRef?.current?.getFieldValue('divisionId') || null;

    const unphasedCostcodes = this.state.chosen.filter((cc) => !cc.phased);

    return (
      <ProjectBudgetTracking
        id={id}
        key={`${id}-budget`}
        onAdd={this.onAddPhaseCode}
        onRemove={this.onRemovePhaseCode}
        unphasedCostcodes={unphasedCostcodes}
        dataSource={this.state.phaseCodes}
        onClearPhasesList={this.onClearPhasesList}
        onClearUnphasedInputs={this.onClearUnphasedInputs}
        costcodes={this.state.chosen.filter((cc) => cc.phased)}
        onEditPhaseCostCodes={this.onEditPhaseCostCodes}
        onEditCostcodeEstimateChanged={this.onEditCostcodeEstimateChanged}
        isNotDisplay={this.isNotDisplay}
        labourHours={labourHours}
        labourCost={labourCost}
        estimatedMaterialCost={estimatedMaterialCost}
        estimatedOverheadCost={estimatedOverheadCost}
        estimatedEquipmentCost={estimatedEquipmentCost}
        estimatedBurdenRate={estimatedBurdenRate}
        estimatedSubContractTotalValue={newEstimatedSubContractTotalValue ?? estimatedSubContractTotalValue}
        contractValue={contractValue}
        startDate={startDate}
        endDate={endDate}
        onEditPhaseDetails={this.onEditPhaseDetails}
        onExport={this.onExport}
        onClearDates={this.onClearDates}
        onClearBudget={this.onClearBudget}
        createNuxEntry={createNuxEntry}
        nux={nux}
        equipment={equipment}
        templateView={templateView}
        divisionId={formDivisionId || divisionId}
        onImportBudget={this.onImportBudget}
        enableBuildEstimate={enableBuildEstimate}
        formRef={formRef}
        templateId={templateId}
      />
    );
  }

  getBudgetPageRedesign() {
    const {
      id,
      divisionId,
      formRef,
      labourHours,
      labourCost,
      estimatedMaterialCost,
      estimatedOverheadCost,
      estimatedEquipmentCost,
      estimatedBurdenRate,
      estimatedSubContractTotalValue,
      contractValue,
      startDate,
      endDate,
      templateView,
      enableBuildEstimate,
      templateId,
      newEstimatedSubContractTotalValue,
    } = this.props;

    const {
      phaseCodes = [],
      chosen = [],
    } = this.state;

    const formDivisionId = formRef?.current?.getFieldValue('divisionId') || null;

    const unphasedCostcodes = chosen.filter((cc) => !cc.phased);
    const costcodes = chosen.filter((cc) => cc.phased);

    const projectEstimates = {
      estimatedMaterialCost,
      estimatedOverheadCost,
      estimatedEquipmentCost,
      estimatedBurdenRate,
      estimatedSubContractTotalValue: newEstimatedSubContractTotalValue
        ?? estimatedSubContractTotalValue,
      contractValue,
      startDate,
      endDate,
      labourHours,
      labourCost,
    };

    return (
      <ProjectBudgetTrackingCreate
        id={id}
        key={`${id}-budget`}
        onAdd={this.onAddPhaseCode}
        onRemove={this.onRemovePhaseCode}
        unphasedCostcodes={unphasedCostcodes}
        phases={phaseCodes}
        costcodes={costcodes}
        onEditPhaseCostCodes={this.onEditPhaseCostCodes}
        onEditCostcodeEstimateChanged={this.onEditCostcodeEstimateChanged}
        isNotDisplay={this.isNotDisplay}
        projectEstimates={projectEstimates}
        onEditPhaseDetails={this.onEditPhaseDetails}
        onClearDates={this.onClearDates}
        templateView={templateView}
        divisionId={formDivisionId || divisionId}
        enableBuildEstimate={enableBuildEstimate}
        formRef={formRef}
        templateId={templateId}
        onApplyTemplate={this.onApplyTemplate}
        onCostcodeAdd={this.onCostcodeAdd}
        onRemoveCostcode={this.onCostCodeRemove}
        chosen={chosen}
        onImportBudget={this.onImportBudget}
      />
    );
  }

  getProgressPage() {
    const {
      id,
      name,
      labourHours,
      labourCost,
      estimatedMaterialCost,
      estimatedOverheadCost,
      estimatedBurdenRate,
      estimatedEquipmentCost,
      estimatedSubContractTotalValue,
      enableBillingDisplay,
      divisionId,
    } = this.props;
    const { activeTab } = this.state;
    let averageWage;

    if (labourHours && labourCost) {
      averageWage = labourCost / labourHours;
    }

    return (
      <ProjectProgress
        projectId={id}
        projectName={name}
        visible={activeTab === PROGRESS_TAB}
        averageWage={averageWage}
        estimatedLaborCost={labourCost}
        estimatedMaterialCost={estimatedMaterialCost}
        estimatedOverheadCost={estimatedOverheadCost}
        estimatedBurdenRate={estimatedBurdenRate}
        estimatedEquipmentCost={estimatedEquipmentCost}
        estimatedSubContractTotalValue={estimatedSubContractTotalValue}
        enableBillingDisplay={enableBillingDisplay}
        divisionId={divisionId}
      />
    );
  }

  getCostTrackingPage() {
    const {
      id,
      divisionId,
      templateId,
    } = this.props;

    const {
      activeTab,
    } = this.state;

    return (
      <CostTracking
        projectId={id}
        divisionId={divisionId}
        visible={activeTab === 'Cost Tracking'}
        templateId={templateId}
      />
    );
  }

  getScheduleOfViewsPage() {
    const {
      id,
      templateId,
    } = this.props;

    return (
      <ProjectScheduleOfValues
        projectId={id}
        templateId={templateId}
      />
    );
  }

  getGanttPage() {
    const {
      id,
      history,
    } = this.props;

    return (
      <GanttSchedule
        history={history}
        projectId={id}
      />
    )
  }

  getFilesPage(isEdit, newName) {
    const {
      name,
      onValuesChanged,
      showFiles,
      onShowFilesChanged,
      divisionId,
      divisions = {},
      showAddFileButton = true,
      showAddFileCheckbox = true,
      fileStructure,
      formRef,
      isFromProjectAddFileTemplates = false,
      onFileSelectedChange,
    } = this.props;

    const formDivisionId = (
      formRef && formRef.current ? formRef.current.getFieldValue('divisionId') : null
    );

    const divisionName = divisions[formDivisionId || divisionId]?.name;
    const pathname = (
      divisionName
        ? `/files/${divisionName}/Projects/${name}`
        : `/files/Projects/${name}`
    );

    return (
      <ProjectAddFiles
        name={newName || name}
        onValuesChanged={onValuesChanged}
        showFiles={isEdit || showFiles}
        onShowFilesChanged={onShowFilesChanged}
        pathname={isEdit ? pathname : ''}
        divisionId={formDivisionId || divisionId}
        divisionName={divisionName}
        isEdit={isEdit}
        showAddFileButton={showAddFileButton}
        showAddFileCheckbox={showAddFileCheckbox}
        defaultFileStructure={fileStructure}
        isFromProjectAddFileTemplates={isFromProjectAddFileTemplates}
        onFileSelectedChange={onFileSelectedChange}
      />
    );
  }

  async tabChanged(activeTab) {
    const {
      tabs,
      id: projectId,
      myProjectTags,
      markProjectTagsAsRead,
      getProjectAttachments,
      paidFlags = [],
    } = this.props;

    const {
      projectTypeId,
      gotAttachments,
    } = this.state;

    const displayedTabs = tabs
      .filter((tab) => (
        tab.category === 'Projects'
        && tab.enabled
        && tab.projectTypeId === projectTypeId
      ))
      .map((tab) => tab.tabName);

    const hasCostTracking = paidFlags?.includes('COST_TRACKING');
    const keyToStep = getKeyToStep(hasCostTracking);

    let step = keyToStep[activeTab];

    // Look at predecessors — deduplicate by step index so that mutually
    // exclusive tabs (e.g. Equipment vs Cost Tracking, both at index 3) only
    // count as one missing step when neither is present.
    if (step > 1) {
      const predecessorsByStepIndex = {};

      Object.keys(keyToStep).forEach((key) => {
        const keyStep = keyToStep[key];
        if (keyStep > 0 && keyStep < step) {
          if (!predecessorsByStepIndex[keyStep]) {
            predecessorsByStepIndex[keyStep] = [];
          }
          predecessorsByStepIndex[keyStep].push(key);
        }
      });

      // For each unique predecessor step index, decrement only if none of the
      // tabs mapped to that index are present in displayedTabs.
      const displayedTabsSet = new Set(displayedTabs);
      Object.values(predecessorsByStepIndex).forEach((tabsAtIndex) => {
        const anyPresent = tabsAtIndex.some((tab) => displayedTabsSet.has(tab));
        if (!anyPresent) {
          step -= 1;
        }
      });
    }

    // Mark project notes as read when notes tab is viewed
    if (activeTab === 'notes' && projectId && myProjectTags) {
      const unreadNoteIds = new Set(
        myProjectTags
          .filter((tag) => tag.projectId === projectId)
          .map((tag) => tag.projectNoteId)
      );
      if (unreadNoteIds.size > 0) {
        markProjectTagsAsRead(unreadNoteIds);
      }
    } else if (activeTab === 'Attachments' && projectId && !gotAttachments) {
      this.setState({
        attachmentsLoading: true,
      });
      await getProjectAttachments(projectId);
      this.setState({
        gotAttachments: true,
        attachmentsLoading: false,
      });
    }

    this.setState({
      activeTab,
      currentStep: step,
    });
    this.props.currentStepChanged(step);
    if (this.props.onActiveTabChange) {
      this.props.onActiveTabChange(activeTab);
    }
  }
  getUnreadNoteCount() {
    const { id: projectId, myProjectTags } = this.props;
    if (!projectId || !myProjectTags) return 0;

    return myProjectTags.filter((tag) => tag.projectId === projectId).length;
  }

  getUnreadNoteIds() {
    const { id: projectId, myProjectTags } = this.props;
    if (!projectId || !myProjectTags) return new Set();

    return new Set(
      myProjectTags
        .filter((tag) => tag.projectId === projectId)
        .map((tag) => tag.projectNoteId),
    );
  }

  async loadSuggestedNumber() {
    const {
      projects = [],
      settings: {
        projectNumberAnchor,
      } = {},
    } = this.props;

    const hasAnchor = !!projectNumberAnchor;
    const { data: { nextNumber } = {} } = await ProjectsService.getNextProjectNumber();

    if (nextNumber) return nextNumber;
    if (hasAnchor) return null;

    if (!projects.length) return '1';
    const highest = getHighestNumber(projects);
    return (highest + 1).toString();
  }

  render() {
    const {
      id: projectId,
      isAdd,
      editing,
      name,
      number,
      description,
      customerId,
      labourHours,
      labourCost,
      estimatedMaterialCost,
      estimatedOverheadCost,
      estimatedEquipmentCost,
      estimatedBurdenRate,
      estimatedSubContractTotalValue,
      contractValue,
      startDate,
      endDate,
      divisionId,
      formRef,
      billingRateId,
      customBillingRate,
      materialDiscount,
      contractExpirationTimestamp,
      contractReminderTimestamp,
      billingContact,
      poNumber,
      info,
      city,
      tabs,
      templateView,
      customSteps = [],
      showContractStep = false,
      t,
      type = null,
      qboClassId,
      firstApprover,
      secondApprover,
      enableBuildEstimate,
      attachments = {},
      address,
      labels = [],
      projectToLabel = {},
      customCategoryEstimates = [],
      paidFlags = [],
    } = this.props;

    const hasCostTracking = paidFlags.includes('COST_TRACKING');

    const {
      projectTypeId,
      activeTab,
      currentStep,
      ourLinks = [],
      attachmentsLoading,
      formDivisionId,
    } = this.state;

    const relevantType = projectTypeId ?? type;
    const displayedTabs = (tabs ?? [])
      .filter((tab) => (
        tab.category === 'Projects'
        && tab.enabled
        && tab.projectTypeId === relevantType
      ))
      .map((tab) => tab.tabName);

    this.isNotDisplay = (isAdd || editing);

    // Get current project labels for editing
    const currentProjectLabels = projectToLabel?.[projectId]?.map((labelId) => {
      const label = labels?.find((l) => l.id === labelId);
      return label || { id: labelId, title: 'Unknown Label' };
    }) ?? [];

    const initialValues = {
      name,
      number,
      description,
      customerId,
      estimatedLabourCost: labourCost,
      estimatedLabourHours: labourHours,
      divisionId,
      estimatedMaterialCost,
      estimatedOverheadCost,
      estimatedEquipmentCost,
      estimatedBurdenRate,
      estimatedSubContractTotalValue,
      contractValue,
      billingRateId,
      customBillingRate,
      materialDiscount: materialDiscount ? materialDiscount * 100 : null,
      billingContact,
      poNumber,
      info,
      city,
      projectTypeId: relevantType,
      qboClassId,
      firstApprover,
      secondApprover,
      enableBuildEstimate,
      address,
      labels: currentProjectLabels,
    };

    // Add project-level custom category estimates to initial values
    if (customCategoryEstimates?.length > 0) {
      customCategoryEstimates.forEach(({ categoryId, value }) => {
        if (!isNullOrUndefined(value)) {
          initialValues[`categoryEstimate.${categoryId}`] = value;
        }
      });
    }

    if (contractExpirationTimestamp) {
      initialValues.contractExpiration = moment(contractExpirationTimestamp);
      if (contractReminderTimestamp) {
        initialValues.contractReminder = calculateExpirationReminder({
          isNotDisplay: true,
          contractExpirationTimestamp,
          contractReminderTimestamp,
        });
      }
    }

    if (startDate && endDate) {
      initialValues.dateRange = [moment(startDate), moment(endDate)];
    }

    const currentName = (
      formRef && formRef.current ? formRef.current.getFieldValue('name') : null
    );

    const steps = [];
    if (!templateView) {
      steps.push({
        content: this.getGeneralPage(),
        title: `${t('Project')} Info`,
        key: 'info',
      });
    }

    if (customSteps) {
      steps.push(...customSteps);
    }

    if (displayedTabs.includes('Billing')) {
      steps.push({
        content: this.getBillingPage(),
        title: 'Billing',
        key: 'billing',
      });
    }

    if (Permissions.has('FILES_WRITE') && isAdd && displayedTabs.includes('Files')) {
      steps.push({
        content: this.getFilesPage(false, currentName),
        title: `${t('Project')} Files`,
        key: 'files',
      });
    }

    if (displayedTabs.includes('Cost Codes') && !hasCostTracking) {
      steps.push({
        content: this.getCostcodePage(),
        title: 'Cost Codes',
        key: 'cc',
      });
    }

    if (config.showEquipment && displayedTabs.includes('Equipment')) {
      steps.push({
        content: this.getEquipmentPage(),
        title: 'Equipment',
        key: 'equipment',
      });
    }

    const hasCostTrackingRead = Permissions.has('PROJECT_BUDGET_TRACKING_READ');
    if (displayedTabs.includes('Budget Tracking') && hasCostTrackingRead) {
      const content = hasCostTracking
        ? this.getBudgetPageRedesign()
        : this.getBudgetPage();
      steps.push({
        content,
        title: hasCostTracking ? 'Cost Tracking' : 'Budget Tracking',
        key: 'budget',
      });
    }

    if (showContractStep) {
      steps.push({
        content: this.getScheduleOfViewsPage(),
        title: 'Contract',
        key: 'contract',
      });
    }

    // The tab count can differ from the step count depending on if
    // the custom project type has different steps set
    if (this.isNotDisplay && this.props.numberOfSteps !== steps.length && this.props.numberOfStepsChanged) {
      this.props.numberOfStepsChanged(steps.length);
    }

    const hasFileRead = Permissions.has('FILES_READ');
    const hasFormsRead = Permissions.has('FORMS_READ');
    const hasScheduleOfValuesRead = Permissions.has('PROJECT_SCHEDULEOFVALUES_READ');
    const hasGanttRead = Permissions.has('PROJECT_GANTT_SCHEDULE_READ');
    const hasProgress = Permissions.has('PROJECT_PROGRESS_READ');

    return (
      <ProjectGlobalCostcodesProvider divisionId={formDivisionId || divisionId}>
      <Form
        ref={formRef}
        layout="vertical"
        style={{
          height: '80%', width: '100%',
        }}
        initialValues={initialValues}
        onValuesChange={(changedValues) => {
          if ('divisionId' in changedValues) {
            this.setState({ formDivisionId: changedValues.divisionId });
          }
        }}
      >
        {this.isNotDisplay ? (
          <StepsContainer
            currentStep={currentStep}
            steps={steps}
          />
        ) : (
          <Tabs
            key={name}
            defaultActiveKey={activeTab}
            destroyInactiveTabPane={!this.isNotDisplay}
            style={activeTab === 'general' ? {
              position: 'absolute',
              bottom: FOOTER_HEIGHT,
              top: 55,
              left: 24,
              right: 24,
            } : {
              marginTop: -24,
            }}
            onChange={this.onTabChange}
            tabBarStyle={{ marginBottom: 10 }}
          >
            <TabPane tab="General Info" key="general" style={tabStyle}>
              {this.getGeneralPage()}
            </TabPane>
            {displayedTabs.includes('Analytics') && config.showProjectAnalytics && Permissions.has('MANAGE_ANALYTICS') && (
              <TabPane tab="Analytics" key={ANALYTICS_TAB} style={tabStyle}>
                {this.getAnalyticsPage()}
              </TabPane>
            )}
            {displayedTabs.includes('Files') && hasFileRead && (
              <TabPane tab="Files" key="Files" style={tabStyle}>
                {this.getFilesPage(true)}
              </TabPane>
            )}

            {displayedTabs.includes('Notes') && projectId && (
              <TabPane
                tab={(
                  <div style={{ paddingRight: this.getUnreadNoteCount() ? 15 : 0 }}>
                    <Badge count={this.getUnreadNoteCount()} offset={[5, -5]}>
                      Notes
                    </Badge>
                  </div>
                )}
                key="notes"
                style={tabStyle}
              >
                <ProjectNotes projectId={projectId} divisionId={divisionId} unreadSet={this.getUnreadNoteIds()} />
              </TabPane>
            )}
            {projectId && (
              <TabPane tab="Attachments" key="Attachments" style={tabStyle}>
                <AttachmentTab attachments={attachments} loading={attachmentsLoading} />
              </TabPane>
            )}
            {displayedTabs.includes('Forms') && hasFormsRead && (
              <TabPane tab="Forms" key="Forms" style={tabStyle}>
                <ProjectFormTemplates projectId={projectId} />
              </TabPane>
            )}
            {displayedTabs.includes('Payables') && (
              <TabPane tab="Payables" key={PAYABLES_TAB} style={tabStyle}>
                {this.getPayablesPage()}
              </TabPane>
            )}
            {displayedTabs.includes('Billing') && (
              <TabPane tab="Billing" key={BILLING_TAB} style={tabStyle}>
                {this.getBillingPage()}
              </TabPane>
            )}
            {displayedTabs.includes('Work Orders') && (
              <TabPane tab="Work Orders" key={WORK_ORDERS_TAB} style={tabStyle}>
                {this.getSimpleFormList('Work Order', activeTab === WORK_ORDERS_TAB)}
              </TabPane>
            )}
            {displayedTabs.includes('Changes') && (
              <TabPane tab="Changes" key={CHANGES_TAB} style={tabStyle}>
                {this.getSimpleFormList('Change Order', activeTab === CHANGES_TAB)}
              </TabPane>
            )}
            {displayedTabs.includes('Other Forms') && (
              <TabPane tab="Other Forms" key={OTHER_FORMS_TAB} style={tabStyle}>
                {this.getOtherFormsList()}
              </TabPane>
            )}
            {displayedTabs.includes('Cost Codes') && !hasCostTracking && (
              <TabPane tab="Cost Codes" key="Cost Codes" style={tabStyle}>
                {this.getCostcodePage()}
              </TabPane>
            )}
            {displayedTabs.includes('Equipment') && config.showEquipment && (
              <TabPane
                tab="Equipment"
                key="Equipment"
                style={tabStyle}
              >
                {this.getEquipmentPage()}
              </TabPane>
            )}
            {displayedTabs.includes('Materials') && config.showMaterials && projectId && (
              <TabPane
                tab="Materials"
                key="Materials"
                style={tabStyle}
              >
                {this.getMaterialsPage()}
              </TabPane>
            )}
            {displayedTabs.includes('Budget Tracking') && hasCostTrackingRead && !hasCostTracking && (
              <TabPane
                tab="Budget Tracking"
                key="Budget Tracking"
                style={tabStyle}
              >
                {this.getBudgetPage()}
              </TabPane>
            )}
            {displayedTabs.includes('Rates') && (
              <TabPane
                tab="Rates"
                key="Rates"
                style={tabStyle}
              >
                {this.getBillingRatesPage()}
              </TabPane>
            )}
            {displayedTabs.includes('Contract') && config.showScheduleOfValues && hasScheduleOfValuesRead && (
              <TabPane
                tab="Contract"
                key="Contract"
                style={tabStyle}
              >
                {this.getScheduleOfViewsPage()}
              </TabPane>
            )}
            {displayedTabs.includes('Progress') && config.showProgress && hasProgress && !hasCostTracking && (
              <TabPane
                tab="Progress"
                key="Progress"
                style={tabStyle}
              >
                {this.getProgressPage()}
              </TabPane>
            )}
            {displayedTabs.includes('Budget Tracking') && hasCostTrackingRead && hasCostTracking && (
              <TabPane
                tab="Cost Tracking"
                key="Cost Tracking"
                style={tabStyle}
              >
                {this.getCostTrackingPage()}
              </TabPane>
            )}
            {displayedTabs.includes('Cards') && ourLinks.length > 0 && (
              <TabPane
                tab="Cards"
                key="Cards"
                style={tabStyle}
              >
                <BoardLinkView links={ourLinks} linkType="projectId" linkId={projectId} />
              </TabPane>
            )}
            {displayedTabs.includes('Gantt') && config.showGantt && hasGanttRead && (
              <TabPane
                tab="Gantt"
                key="Gantt"
                style={tabStyle}
              >
                {this.getGanttPage()}
              </TabPane>
            )}
          </Tabs>
        )}
      </Form>
      </ProjectGlobalCostcodesProvider>
    );
  }
}

ProjectAddView.propTypes = {
  id: PropTypes.string,
  number: PropTypes.string,
  onValuesChanged: PropTypes.func.isRequired,
  onFileSelectedChange: PropTypes.func,
  onActiveTabChange: PropTypes.func,
};

ProjectAddView.defaultProps = {
  id: undefined,
  number: undefined,
  onFileSelectedChange: () => {},
  onActiveTabChange: undefined,
};

const mapStateToProps = (state, ownProps) => ({
  attachments: state.projects.projectAttachments,
  projectToLabel: state.projects.projectToLabel,
  labels: state.labels,
  myProjectTags: state.projects.myProjectTags,
  projectTagsPerProject: state.projects.projectTagsPerProject,
  newEstimatedSubContractTotalValue: state.projects.newEstimatedSubContractTotalValues[ownProps.id],
  categoryAssignments: state.costcodes.categoryAssignments,
  paidFlags: state.settings.company?.paidFlags ?? [],
});

export default withTranslation()(
  connect(mapStateToProps, {
    getProjectAttachments,
    getBuckets,
    getMyProjectTags,
    markProjectTagsAsRead,
    getCostcodeCategoryAssignmentData,
    getProjectCustomCategoryEstimates,
  })(ProjectAddView),
);
